import FullScreenSpinner from '@components/FullScreenSpinner/FullScreenSpinner';
import { appWithTranslation } from 'next-i18next';
import type { AppProps } from 'next/app';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import Script from 'next/script';
import '../styles/globals.css';

const Application = dynamic(() => import('features/app/Application'), {
  ssr: false,
  loading: () => <FullScreenSpinner />
});

function MyApp({ Component, pageProps }: AppProps) {
  return (
    <Application>
      <>
        <Head>
          <title>Toko Kapital</title>
        </Head>
        { /* eslint-disable-next-line react/jsx-props-no-spreading */ }
        <Component {...pageProps} />
        <Script
          src="https://goplatform.gojekapi.com/js-sdk/0.6.1/stewie.js"
        />
      </>
    </Application>
  );
}

export default appWithTranslation(MyApp);
